import { useIsomorphicLayoutEffect } from 'swr/_internal'
import { useEffectEvent } from 'use-effect-event'

import { useSession } from '@/legacy-src/contexts/session-context'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { OFFLINE_NOT_AVAILABLE } from '@/src/domains/client-booking/constants'
import { useFreeSlotTypeQueryFilterWithAvailability } from '@/src/domains/client-booking/hooks/useFreeSlotTypeQueryFilterWithAvailability'
import { useGetDiagnosis } from '@/src/domains/diagnosis/hooks/useGetDiagnosis'

import { ClientBookingFreeSlotTypeFilterUI } from './ClientBookingFreeSlotTypeFilter.ui'
import { getFreeSlotTypeFilterFromDiagnosis } from './ClientBookingFreeSlotTypeFilter.utils'

export interface ClientBookingFreeSlotTypeFilterProps {
  therapist: TherapistType
  className?: string
}

export const ClientBookingFreeSlotTypeFilter = ({ therapist, className }: ClientBookingFreeSlotTypeFilterProps) => {
  const { isLoggedIn } = useSession()

  const { data } = useGetDiagnosis(undefined, {
    suspense: true,
    readyToFetch: isLoggedIn,
  })

  const { filter, rawFilter, pushFilter } = useFreeSlotTypeQueryFilterWithAvailability({ therapist })

  const handleDefaultFilter = useEffectEvent(() => {
    const defaultFilter = getFreeSlotTypeFilterFromDiagnosis(data?.diagnosis, filter, rawFilter)

    if (defaultFilter !== undefined) {
      pushFilter(defaultFilter)
    }
  })

  useIsomorphicLayoutEffect(() => {
    handleDefaultFilter()
  }, [data])

  if (filter === OFFLINE_NOT_AVAILABLE) {
    return null
  }

  return <ClientBookingFreeSlotTypeFilterUI value={filter} onChange={pushFilter} className={className} />
}
